<template>
  <a-checkbox-group
    v-if="props.useGrid"
    :class="[bem.b(), bem.is('use-grid')]"
    v-bind="attrs"
  >
    <a-row
      :gutter="[gutterHorizontal, gutterVertical]"
      v-bind="props.rowOptions"
    >
      <a-col
        v-for="(item, idx) in props.options"
        v-bind="item.colOptions"
        :key="idx"
        :span="item.span || props.allSpan"
      >
        <checkbox v-bind="item">
          <slot name="label" v-bind="item">
            {{ item.label }}
          </slot>
        </checkbox>
      </a-col>
    </a-row>
  </a-checkbox-group>
  <a-checkbox-group
    v-else
    :class="[bem.b(), bem.is(groupDirection)]"
    :options="props.options"
    :style="itemSpace"
    v-bind="attrs"
  />
</template>

<script setup lang="ts">
import { computed, useAttrs } from 'vue'
import { checkboxGroupProps } from './checkbox'
import Checkbox from './checkbox.vue'

import { createNamespace } from '@ll-plus/utils'

defineOptions({ name: 'LlCheckboxGroup' })

const props = defineProps(checkboxGroupProps)

const bem = createNamespace('checkbox-group')

const attrs = useAttrs()

const groupDirection = computed(() =>
  props.direction === 'vertical' ? 'vertical' : 'horizontal'
)

const itemSpace = computed(() => ({
  gap: props.itemSpace + 'px',
}))
</script>
